// extracted by mini-css-extract-plugin
export var card = "NavRail-module--card--c780c";
export var inset = "NavRail-module--inset--28386";